<template>
    <div class="flex w-full sports-page">
        <div>
            <!-- commented so it doesn't break design -->
            <!-- <BannerContainer :page="page"/> -->
        </div>
        <div class="flex w-full">
            <SpecialContainer/>
        </div>
    </div>
</template>

<script>
    import SpecialContainer from '@src/terminal/app/modules/specialOffer/SpecialContainer';
    import { BannerCategory } from '@core/models/banners/enums';

    export default {
        name: 'SpecialPage',
        data() {
            return {
                page: BannerCategory.special,
            };
        },
        components: {
            SpecialContainer,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/pages/SpecialPageTerminal.vue